/**
 * Store sub context for modal data
 */
const ModalContext = {
  modal: false,
  modalType: '',
  modalAction: '',
  modalData: {} as any
};

export default ModalContext;
